import type { SVGProps } from "react"

export default function CheckboxIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect x="0.5" y="0.5" width="23" height="23" rx="2" stroke="#D0D0D0" strokeWidth="1" />
    </svg>
  )
}
